import React from "react";
import { css, useTheme } from "@emotion/react";

type Props = {
    children: React.ReactNode,
    isFormOnTheTop: boolean,
};

const Wrapper: React.FC<Props> = ({
    children,
    isFormOnTheTop,
}) => {
    const theme = useTheme();

    const style = css`
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        width: 100%;
        
        ${theme.breakpoints.down("md")} {
            padding-top: 50px;
            align-items: center;
            flex-direction: ${isFormOnTheTop ? 'column' : 'column-reverse'};
        }
    `;

    return (
        <div css={style}>{children}</div>
    );
};

export default Wrapper;
